import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import React, { FC, useState, useEffect, memo, useMemo } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import InfiniteScroll from "../../../ui/InfiniteScroll";
import ListItem from "../../../ui/ListItem";
import SearchInput from "../../../ui/SearchInput";
import { CongNoApi } from "../../restapi/congNoApi";
import worker from "../../setupWorker";
import Loading from "../../ui/loading";
import { getCurDate } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import CardCongNoChiTiet from "./cardCongNoChiTiet";
import NhapSuaChungTu from "./nhapSuaChungTu";


type OwnProps = {
    onBackToCongNoTongHop: () => void,
    contactId: number;
}
const CongNoChiTiet: FC<OwnProps> = ({
    onBackToCongNoTongHop,
    contactId,
}) => {
    const [state, setState] = useState({
        chungTu: [],
        cnth: { phaiThu: 0, phaiTra: 0, daThu: 0, daTra: 0, name: "" },
        nam: (new Date()).getFullYear(),
        reload: new Date(),
        editOpen: false,
        deleteOpen: false,
        editingChungTu: { ngay: getCurDate(), chungTuId: 0 },
        isLoading: false,
    })
    const listIds = useMemo(() => {
        const result: number[] = []
        const len = state.chungTu.length;
        for (let i = 0; i < len; i++) {
            result.push(i)
        }
        return result
    }, [state.chungTu]);
    useEffect(() => {
        const tuNgay = `${state.nam-1}-01-01`
        const denNgay = `${state.nam}-12-31`
        const payload = { contactId, tuNgay, denNgay }
        setState(prev => ({ ...prev, isLoading: true }))
        CongNoApi.GetCongNoChiTiet(payload).then(res => {
            setState(prev => ({ ...prev, isLoading: false }))
            if (res.errorCode == 0) {
                setState(prev => ({ ...prev, chungTu: res.data, cnth: res.dataEx }))
            } else {
                worker.postMessage({ type: 'showsnackbar', data: res.responseText })
            }

        })
    }, [state.reload])
    const [viewportIds, getMore] = useInfiniteScroll(undefined, listIds, false, 50, undefined);
    function handleOnReloadData() {
        setState(prev => ({ ...prev, reload: new Date() }))
    }
    function handleOnEditChungTu(chungTu: any) {
        setState(prev => ({ ...prev, editOpen: true, editingChungTu: chungTu }))
        //console.log('edit chung tu', chungTu)
    }
    function handleOnDeleteChungTu(chungTu: any) {
        setState(prev => ({ ...prev, deleteOpen: true, editingChungTu: chungTu }))
        //console.log('edit chung tu', chungTu)
    }
    function getTitle(): string {
        let ret = ` Hết nợ`
        const cn = state.cnth.phaiThu + state.cnth.daTra -
            state.cnth.daThu - state.cnth.phaiTra
        if (cn > 0) {
            ret = ` thu ${tienFormat(cn, 1)}`
        } else if (cn < 0) {
            ret = ` bù ${tienFormat(cn, 1)}`
        }
        return ret
    }
    const title = getTitle()
    return (
        <>
            <div className=" form-content">
                <div className=" form-header">
                    <div className=" form-header left-panel">
                        <Button round size='tiny'
                            onClick={onBackToCongNoTongHop}
                        ><i className=" icon icon-arrow-left"></i></Button>
                        <div>
                            {state.cnth.name}
                        </div>
                        <div className={title.startsWith(" bù") ? "phaiTra" : "phaiThu"}>
                            {title}
                        </div>
                    </div>
                    <div className=" form-header right-panel">
                        {/* <Button round size='tiny'><i className=" icon icon-document"></i></Button> */}
                    </div>
                </div>
                <div className=" form-content with-search">
                    {state.isLoading ? <Loading />
                        : <InfiniteScroll 
                            items={viewportIds} onLoadMore={getMore} className="chat-list custom-scroll"

                        >
                            {
                                listIds.map((ct: any, index: number) => {
                                    const item: any = state.chungTu[index]
                                    return <div key={"ct" + index} style={'padding: 10px 0 10px 0;'}>
                                        <ListItem
                                        >
                                            <CardCongNoChiTiet cardData={item}
                                                onDeleteChungTu={handleOnDeleteChungTu}
                                                onEditChungTu={handleOnEditChungTu} />
                                        </ListItem>
                                    </div>
                                })
                            }
                        </InfiniteScroll>
                    }
                </div>

            </div >
            <NhapSuaChungTu isOpen={state.editOpen} data={{ chungTu: state.editingChungTu }}
                onClose={() => setState(prev => ({ ...prev, editOpen: false }))}
                onDataSaved={handleOnReloadData}
            ></NhapSuaChungTu>
            <ConfirmDialog isOpen={state.deleteOpen}
                confirmLabel="Xoá"
                title="Xoá chứng từ"
                text="Chứng từ sau khi xoá không thể khôi phục"
                confirmHandler={() => {
                    setState(prev => ({ ...prev, deleteOpen: false }))
                    const payload = { chungTuId: state.editingChungTu.chungTuId }
                    CongNoApi.DeleteChungTu(payload).then(res => {
                        worker.postMessage({ type: 'showsnackbar', data: res.responseText })
                        setState(prev => ({ ...prev, reload: new Date() }))
                    }
                    )
                }}
                onClose={() => setState(prev => ({ ...prev, deleteOpen: false }))}
            ></ConfirmDialog>
        </>)
}

export default memo(CongNoChiTiet)